import React from 'react';
import Report from './Report';
import { ReportProvider } from '../../contexts/ReportContext';
import withAuthentication from '../../hocs/withAuthentication';
const Page: React.FC = () => {
    return (
        <ReportProvider>
            <Report/>
        </ReportProvider>
    );
};

export default withAuthentication(Page);